/* eslint-disable react/jsx-pascal-case */
import {
  Navbar,
  Container,
  Nav,
  Button,
  OverlayTrigger,
  Popover,
  InputGroup,
  Form,
  Offcanvas,
  NavDropdown,
} from "react-bootstrap";

import CompOffcanvas from "./Sidebar";
import * as Icon from "react-bootstrap-icons";
import {
  setMasquerade,
  setReportList,
  setRoute,
} from "../../store/reducers/reducer-auth";
import { useDispatch, useSelector } from "react-redux";

import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  setAccountOptions,
  setLenderID,
  setManualSelectedAccount,
  setSelectedAccount,
  setSelectedRole,
} from "../../store/reducers/accountSlice";
import {
  handleTermsPopup,
  setDashboardStatus,
} from "../../store/reducers/dashboardSlice";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import TimeoutModal from "../TimeoutModal";
import axios from "../../axios";
import { selected_authentication_server } from "../../deployment-config";
import TimeoutModalWithoutValidation from "../TimeoutModalWithoutValidation";
import { useSetUserLoggedIn } from "../../pages/Login/LoginComp";
import useLogout from "../../hooks/useLogout";
import { roleType } from "../../Utils/constant";
import { useAbortController } from "../../hooks/useAbortController";
import { handleDocSearchModal } from "../../store/reducers/reducer-sidebar";
import GoogleTranslate from "../GoogleTranslate";
import HamburgerMenu from "mdi-react/HamburgerMenuIcon";
import { useState } from "react";
import { BlurWrapper, BlurWrapperWithSpan } from "../../Utils/CustomComponent";
import SearchLoan from "../SearchLoan/SearchLoan";
import { leaveLoanDetailsOnAccountSwitch } from "../../Utils/leaveLoanDetailsOnAccountSwitch";

// import useHolidayTheme from "../../hooks/useHolidayTheme";
// import { useNavigate } from "react-router-dom";

// const shouldHighlight = (option) => {
//   return option?.label?.split(":")?.length === 3;
// };

// const customStyles = {
//   option: (provided, state) => {
//     const isHighlighted = shouldHighlight(state?.data); // Check if this option should be highlighted

//     return {
//       ...provided,
//       backgroundColor: state.isSelected
//         ? provided?.backgroundColor
//         : isHighlighted
//         ? "yellow"
//         : provided?.backgroundColor,
//       color: isHighlighted ? "black" : provided?.color,

//       // ":hover": {
//       //   backgroundColor: isHighlighted
//       //     ? "gold"
//       //     : provided?.[":hover"].backgroundColor,
//       // },
//     };
//   },
// };

// const sortOptions = (options, condition) => {
//   return [...options].sort((a, b) => {
//     // Replace this with your condition logic
//     if (condition(a) && !condition(b)) return 1; // `b` comes before `a`
//     if (!condition(a) && condition(b)) return -1; // `a` comes before `b`
//     return a.label.localeCompare(b.label); // Fallback to alphabetical order
//   });
// };

const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const formatGroupLabel = (group) => (
  <div style={groupStyles}>{group?.label}</div>
);

const SSLNavbar = ({ sideBar = true, showNavButtons = true }) => {
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [showLoanSearch, setShowLoanSearch] = useState(false);

  const { resetController } = useAbortController();
  const holidayTheme = false;
  // const { holidayTheme } = useHolidayTheme();

  const logout = useLogout();
  const location = useLocation();
  const setUserLoggedIn = useSetUserLoggedIn();
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const roleOptions = useSelector((state) => state.account.roleOptions);
  const selectedRoleObj = useSelector((state) => state.account.selectedRole);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const selectedRoleName = useSelector(
    (state) => state?.account?.selectedRole?.label
  );
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value
  );
  const selectedRoleLabel = useSelector(
    (state) => state?.account?.selectedRole?.label
  );
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade
  );
  const navCondition =
    selectedRole === "B" &&
    (!location.pathname?.includes("/support") ||
      location.pathname !== "/account" ||
      location.pathname !== "/help" || location.pathname !== "/demand-payoff-auth");

  const { toggleNavbar, isLargeDevice } = useSelector(
    (state) => state.RS_Sidebar
  );
  const { languageDetected } = useSelector((state) => state.dashboard);
  const isDemoAccount = useSelector((state) => state.account.isDemoAccount);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  const isABorrower = selectedRoleName?.includes("Borrower");

  const handleAccountSubmit = (e) => {
    if (e?.value) {
      if (location.pathname.includes("/loan-details")) {
        dispatch(handleTermsPopup(true));
        navigate("/");
      }
      resetController();
      dispatch(setSelectedAccount(e));
      dispatch(setLenderID(e?.value));
      dispatch(setDashboardStatus("idle"));
      toast.success("Account Changed", {
        ...commonToast,
      });
    }
  };
  const handleRoleSubmit = (value) => {
    const detailRole = JSON.parse(
      JSON.parse(localStorage?.getItem("user-details"))?.details?.roles
    )?.filter((data) => data?.role_type === value)[0];
    const updatedRoute = detailRole?.nav_menu
      ?.sort((a, b) => a?.menu_order - b?.menu_order)
      ?.map((data) => data?.menu_name) || ["Account"];
    const reportNameList = detailRole?.report_list;
    resetController();
    dispatch(setRoute(updatedRoute));
    dispatch(setReportList(reportNameList));
    dispatch(setDashboardStatus("idle"));
    navigate("/");
  };
  const handleRoleChange = (e) => {
    dispatch(setSelectedRole(e));
    // const isBorrower = e?.label?.includes("Borrower");

    const selectedRoleAccountOptions = JSON.parse(
      localStorage?.getItem("accessed_user")
    )
      .account?.filter((data) => data.type === e.value)
      ?.map((data) => ({
        label:
          // isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
          //   ? `${data?.fullname} : ${data?.account} : ${data?.paidoffdate}`
          //   :
          `${data?.fullname} - ${data?.account}`,
        value: data.recid,
        databasename: data.databasename,
      }));
    if (selectedRoleAccountOptions?.length) {
      dispatch(setAccountOptions(selectedRoleAccountOptions));
      dispatch(setSelectedAccount(selectedRoleAccountOptions[0]));
      dispatch(setLenderID(selectedRoleAccountOptions[0]?.value));
      dispatch(setManualSelectedAccount({}));
      handleRoleSubmit(e?.value);
    } else {
      dispatch(setAccountOptions([]));
      dispatch(setSelectedAccount({}));
      dispatch(setManualSelectedAccount({}));
      dispatch(setLenderID(""));
      navigate("/add_account");
    }
  };
  const backToOrigin = async () => {
    const res2 = await axios.post(
      selected_authentication_server.access_account.endpoint,
      { userid: localStorage.getItem("backToOrigin") },
      selected_authentication_server.access_account.headers
    );
    setUserLoggedIn({ res: res2 });
    dispatch(
      setMasquerade({
        isIt: false,
        p_logged_in_email: "",
        p_session: "",
        p_ticket_id: "",
      })
    );
    localStorage.removeItem("backToOrigin");
  };

  function handleSearchBox() {
    dispatch(handleDocSearchModal(true));
  }

  // const sortedOptions = sortOptions(
  //   accountOptions,
  //   (option) => option?.label?.split(":")?.length === 3
  // );

  return (
    <>
      {masqueradeEmail.isIt && (
        <div
          className="container-fluid overflow-hidden fixed-top"
          style={{
            background: "#FFFF00",
            zIndex: 10000,
            top: languageDetected ? "40px" : "0px",
          }}
        >
          <div className="row">
            <div className="col-12 position-relative">
              {!isDemoAccount ? (
                <div
                  className="d-flex py-3 my-marquee"
                  style={{
                    padding: "10px",
                    fontSize: isLargeDevice ? "18px" : "15px",
                  }}
                >
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    {masqueradeEmail?.p_logged_in_email || ""}
                  </span>
                  &nbsp; is &nbsp;masquerading &nbsp;as &nbsp;
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    {userDetails?.email || ""}
                  </span>
                </div>
              ) : (
                <div
                  className="d-flex py-3 my-marquee"
                  style={{
                    padding: "10px",
                    fontSize: isLargeDevice ? "18px" : "15px",
                  }}
                >
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Demo Account!!!
                  </span>
                </div>
              )}
            </div>
          </div>
          {localStorage.getItem("backToOrigin") ? (
            <TimeoutModalWithoutValidation />
          ) : (
            <TimeoutModal />
          )}
        </div>
      )}
      <Navbar
        fixed="top"
        bg="white"
        variant="white"
        expand="lg"
        // className={holidayTheme ? "text-white" : ""}
        style={{
          background: "#eeeeee",
          paddingTop: masqueradeEmail.isIt
            ? `calc(36px + ${languageDetected ? "40px" : "0px"})`
            : languageDetected
            ? "40px"
            : "",
        }}
      >
        <Container
          fluid
          style={holidayTheme ? { backgroundColor: "#bd3e2f" } : null}
        >
          {sideBar ? (
            <Navbar.Brand href="#">
              <CompOffcanvas
                logout={() => {
                  logout();
                }}
                placement="start"
                name="start"
              ></CompOffcanvas>
            </Navbar.Brand>
          ) : null}

          {!toggleNavbar ? (
            // <Navbar.Toggle
            //   aria-controls="navbarScroll"
            //   className="bg-primary"
            //   color="red"
            // />
            <Button
              className="kd-sidebar-button-2 p-4 d-sm-flex d-lg-none justify-content-center align-items-top"
              aria-controls="navbarScroll"
              onClick={() => setShowMobileNav((prev) => !prev)}
            >
              <HamburgerMenu />
            </Button>
          ) : null}

          {!toggleNavbar ? (
            isLargeDevice ? (
              <Navbar.Collapse id="navbarScroll">
                <Nav
                  className=" my-2 my-lg-0"
                  style={{ maxHeight: "100px" }}
                  navbarScroll
                ></Nav>
                <div className="d-flex text-center align-items-center justify-content-center p-0 m-0 w-100">
                  {/* <strong className='p-0'>SLS Portal</strong> */}
                </div>
                {/* <div className="d-flex justify-content-start align-items-center w-100">
              <strong className="p-0">{selectedRoleName}</strong>{" "}
            </div> */}
                <div className="d-flex justify-content-center align-items-center ms-5 navbar-role">
                  <GoogleTranslate />
                </div>
                {roleOptions?.length ? (
                  <div
                    className="d-flex justify-content-center align-items-center me-5 navbar-role"
                    style={{ minWidth: "20%" }}
                  >
                    <Select
                      options={roleOptions}
                      value={selectedRoleObj ? selectedRoleObj : null}
                      onChange={handleRoleChange}
                      classNamePrefix="select"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          primary: "#ef8860",
                        },
                      })}
                    />
                  </div>
                ) : null}

                {accountOptions?.length &&
                location.pathname !== "/borrower-dashboard-two" &&
                !location.pathname?.includes("/loan-details-borrower") &&
                location.pathname !== "/ach-payment" &&
                location.pathname !== "/one-time-payment" &&
                location.pathname !== "/one-time-payment/form" &&
                location.pathname !== "/preview-check" &&
                location.pathname !== "/manage-banking" &&
                location.pathname !== "/nsf" &&
                location.pathname !== "/nsf/payment-selection" &&
                location.pathname !== "/same-day-payment" &&
                location.pathname !== "/nsf/one-time-payment" &&
                location.pathname !== "/nsf/same-day-payment" &&
                location.pathname !== "/loans" &&
                location.pathname !== "/add-bank-account" &&
                !location.pathname.includes("/update-bank-account") &&
                location.pathname !== "/voms/borrower" &&
                !navCondition ? (
                  <div
                    className="d-flex justify-content-center align-items-center mx-5 navbar-account"
                    style={{ minWidth: "30%" }}
                  >
                    <BlurWrapperWithSpan>
                      {/* <Select
                        // options={accountOptions}
                        options={
                          selectedRoleName?.includes("Borrower")
                            ? sortedOptions
                            : accountOptions
                        }
                        value={selectedAccount ? selectedAccount : null}
                        onChange={handleAccountSubmit}
                        // styles={customStyles}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary: "#ef8860",
                          },
                        })}
                        // theme={(theme) => customTheme(theme, selectedAccount)}
                        className="w-100 my-3 text-start"
                        formatGroupLabel={isABorrower ? formatGroupLabel : null}
                      /> */}
                      <SelectAccount
                        isABorrower={isABorrower}
                        selectedRoleName={selectedRoleName}
                      />
                    </BlurWrapperWithSpan>
                  </div>
                ) : null}
                {selectedRole !== roleType.borrower && (
                  <div
                    className="d-flex align-items-center me-4"
                    role="button"
                    onClick={() => setShowLoanSearch(true)}
                  >
                    <Icon.Search />
                  </div>
                )}
                <div className="d-flex align-items-center">
                  <OverlayTrigger
                    rootClose={true}
                    trigger="click"
                    key={"bottom-1"}
                    placement={"bottom"}
                    overlay={
                      <Popover id={`popover-positioned-${"bottom"}`}>
                        <Popover.Header
                          as="h3"
                          className="bg-primary text-white"
                        >
                          Notifications
                        </Popover.Header>
                        <Popover.Body>
                          <p>No new notifications!</p>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <div
                      className={`d-flex justify-content-center align-items-center ${
                        holidayTheme ? "text-white" : ""
                      }`}
                    >
                      <Icon.BellFill />
                      <span className="notification-dot"></span>
                    </div>
                  </OverlayTrigger>

                  <OverlayTrigger
                    rootClose={true}
                    trigger="click"
                    key={"bottom-2"}
                    placement={"bottom"}
                    overlay={
                      <Popover id={`popover-positioned-${"bottom"}`}>
                        <Popover.Header
                          as="h3"
                          className="bg-primary text-white"
                        >
                          <BlurWrapperWithSpan>
                            Hello {userDetails?.username || ""}!
                          </BlurWrapperWithSpan>
                        </Popover.Header>
                        <Popover.Body>
                          {masqueradeEmail?.isIt &&
                          localStorage.getItem("backToOrigin") ? (
                            <Button
                              onClick={backToOrigin}
                              className="btn text-start w-100 mb-3 d-flex align-items-center"
                              style={{ padding: "6px 0px" }}
                              variant={"light"}
                            >
                              <Icon.ArrowBarLeft className="me-2" />
                              Back to Origin
                            </Button>
                          ) : (
                            <>
                              {" "}
                              {showNavButtons && !masqueradeEmail.isIt && (
                                <Button
                                  className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start manage-account customNav px-3"
                                  style={{ padding: "6px 0px" }}
                                  variant={"light"}
                                  onClick={() => navigate("/manage-account")}
                                >
                                  <Icon.GearFill className="me-2" />
                                  {"Manage Account"}
                                </Button>
                              )}
                              {(selectedRoleName?.includes("Lender Admin") ||
                                selectedRoleName?.includes("Broker Admin") ||
                                selectedRoleName?.includes("Borrower Admin")) &&
                                showNavButtons &&
                                !masqueradeEmail.isIt && (
                                  <>
                                    {selectedRole !== roleType.borrower && (
                                      <Button
                                        className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start customNav px-3"
                                        style={{ padding: "6px 0px" }}
                                        variant={"light"}
                                        onClick={() => navigate("/role-menu")}
                                      >
                                        <Icon.GearFill className="me-2" />
                                        {"Manage Role"}
                                      </Button>
                                    )}
                                    <Button
                                      className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start customNav px-3"
                                      style={{ padding: "6px 0px" }}
                                      variant={"light"}
                                      onClick={() => navigate("/admin-menu")}
                                    >
                                      <Icon.GearFill className="me-2" />
                                      {"Admin Menu"}
                                    </Button>
                                  </>
                                )}
                              {(selectedRole === roleType.broker ||
                                selectedRole === roleType.brokerAdmin) &&
                                !masqueradeEmail.isIt && (
                                  <>
                                    <Button
                                      className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start customNav px-3"
                                      style={{ padding: "6px 0px" }}
                                      variant={"light"}
                                      onClick={() =>
                                        navigate("/lender-onboard")
                                      }
                                    >
                                      <Icon.GearFill className="me-2" />
                                      {"Manage Lender Onboarding"}
                                    </Button>
                                  </>
                                )}
                              {/* {userDetails?.user_id === "66151" && ( */}
                              {/* {(selectedRoleName === "Lender" ||
                                selectedRoleName === "Lender Admin" ||
                                selectedRoleName === "Broker") &&
                                !masqueradeEmail.isIt &&
                                userDetails?.user_id == "66151" && (
                                  <>
                                    <Button
                                      className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start"
                                      style={{ padding: "6px 0px" }}
                                      variant={"light"}
                                      onClick={() =>
                                        navigate("/submit-a-loan/form")
                                      }
                                    >
                                      <Icon.GearFill className="me-2" />
                                      {"Loan Onboarding"}
                                    </Button>
                                  </>
                                )} */}
                            </>
                          )}
                          {/* {selectedRoleName === "Borrower" &&
                            !masqueradeEmail.isIt && (
                              <Button
                                className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start customNav px-3"
                                style={{ padding: "6px 0px" }}
                                variant={"light"}
                                onClick={() => navigate("/api-documentation")}
                              >
                                <Icon.Receipt className="me-2" />
                                {"API Documentation"}
                              </Button>
                            )} */}
                          <Button
                            onClick={() => {
                              logout();
                            }}
                            className="btn text-start w-100 mb-3 d-flex align-items-center customNav px-3"
                            style={{ padding: "6px 0px" }}
                            variant={"light"}
                          >
                            <Icon.ArrowBarLeft className="me-2" />
                            {"Logout"}
                          </Button>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <Button
                      variant="secondary"
                      className={`d-flex align-items-center justify-content-center p-0 profile-section ${
                        holidayTheme ? "text-white" : ""
                      }`}
                      style={{ marginLeft: "6px" }}
                    >
                      <Icon.PersonCircle size={25} className="me-1" />
                      <BlurWrapper>
                        <p style={{ width: "100%", margin: "0px" }}>
                          {/* {userDetails?.username || ""} */}
                          {userDetails?.first_name !== null &&
                          userDetails?.last_name !== null ? (
                            <div className="d-flex gap-2 align-items-center">
                              <span>{userDetails.first_name}</span>
                              <span>{userDetails.last_name}</span>
                            </div>
                          ) : (
                            userDetails.email
                          )}
                        </p>
                      </BlurWrapper>
                      <Icon.ChevronDown size={15} className="mt-2" />
                    </Button>
                  </OverlayTrigger>
                </div>
              </Navbar.Collapse>
            ) : (
              <Offcanvas
                show={showMobileNav}
                id={`navbarScroll`}
                aria-labelledby={`offcanvasNavbarLabel-expand`}
                placement="end"
                onHide={() => setShowMobileNav(false)}
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title
                    id={`offcanvasNavbarLabel-expand`}
                  ></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3 gap-5">
                    <div className={`${isLargeDevice ? "d-none" : ""}`}>
                      <GoogleTranslate />
                    </div>
                    <div className="navbar-role">
                      <Select
                        options={roleOptions}
                        value={selectedRoleObj ? selectedRoleObj : null}
                        onChange={handleRoleChange}
                        classNamePrefix="select"
                      />
                    </div>
                    <div className="navbar-account">
                      <Select
                        options={accountOptions}
                        value={selectedAccount ? selectedAccount : null}
                        onChange={handleAccountSubmit}
                        className="w-100 my-3 text-start"
                      />
                    </div>
                    <NavDropdown
                      title="Notifications"
                      id={`offcanvasNavbarNotifications-expand`}
                      className=""
                    >
                      <NavDropdown.Item href="#">
                        No new notifications!
                      </NavDropdown.Item>
                    </NavDropdown>

                    <OverlayTrigger
                      rootClose={true}
                      trigger="click"
                      key={"bottom-2"}
                      placement={"bottom"}
                      overlay={
                        <Popover id={`popover-positioned-${"bottom"}`}>
                          <Popover.Header
                            as="h3"
                            className="bg-primary text-white"
                          >
                            Hello {userDetails?.username || ""}!
                          </Popover.Header>
                          <Popover.Body>
                            {masqueradeEmail?.isIt &&
                            localStorage.getItem("backToOrigin") ? (
                              <Button
                                onClick={backToOrigin}
                                className="btn text-start w-100 mb-3 d-flex align-items-center"
                                style={{ padding: "6px 0px" }}
                                variant={"light"}
                              >
                                <Icon.ArrowBarLeft className="me-2" />
                                Back to Origin
                              </Button>
                            ) : (
                              <>
                                {" "}
                                {showNavButtons && !masqueradeEmail.isIt && (
                                  <Button
                                    className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start manage-account customNav"
                                    style={{ padding: "6px 0px" }}
                                    variant={"light"}
                                    onClick={() => navigate("/manage-account")}
                                  >
                                    <Icon.GearFill className="me-2" />
                                    {"Manage Account"}
                                  </Button>
                                )}
                                {(selectedRoleName?.includes("Lender Admin") ||
                                  selectedRoleName?.includes("Broker Admin") ||
                                  selectedRoleName?.includes(
                                    "Borrower Admin"
                                  )) &&
                                  showNavButtons &&
                                  !masqueradeEmail.isIt && (
                                    <>
                                      {selectedRole !== roleType.borrower && (
                                        <Button
                                          className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start"
                                          style={{ padding: "6px 0px" }}
                                          variant={"light"}
                                          onClick={() => navigate("/role-menu")}
                                        >
                                          <Icon.GearFill className="me-2" />
                                          {"Manage Role"}
                                        </Button>
                                      )}
                                      <Button
                                        className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start"
                                        style={{ padding: "6px 0px" }}
                                        variant={"light"}
                                        onClick={() => navigate("/admin-menu")}
                                      >
                                        <Icon.GearFill className="me-2" />
                                        {"Admin Menu"}
                                      </Button>
                                    </>
                                  )}
                                {(selectedRole === roleType.broker ||
                                  selectedRole === roleType.brokerAdmin) &&
                                  !masqueradeEmail.isIt && (
                                    <>
                                      <Button
                                        className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start"
                                        style={{ padding: "6px 0px" }}
                                        variant={"light"}
                                        onClick={() =>
                                          navigate("/lender-onboard")
                                        }
                                      >
                                        <Icon.GearFill className="me-2" />
                                        {"Manage Lender Onboarding"}
                                      </Button>
                                    </>
                                  )}
                                {(selectedRoleName === "Lender" ||
                                  selectedRoleName === "Lender Admin" ||
                                  selectedRoleName === "Broker") &&
                                  !masqueradeEmail.isIt && (
                                    <>
                                      <Button
                                        className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start"
                                        style={{ padding: "6px 0px" }}
                                        variant={"light"}
                                        onClick={() =>
                                          navigate("/submit-a-loan/form")
                                        }
                                      >
                                        <Icon.GearFill className="me-2" />
                                        {"Loan Onboarding"}
                                      </Button>
                                    </>
                                  )}
                                {selectedRoleName === "Borrower" &&
                                  !masqueradeEmail.isIt && (
                                    <Button
                                      className="btn text-start w-100 mb-3 d-flex align-items-center justify-content-start"
                                      style={{ padding: "6px 0px" }}
                                      variant={"light"}
                                      onClick={() =>
                                        navigate("/api-documentation")
                                      }
                                    >
                                      <Icon.Receipt className="me-2" />
                                      {"API Documentation"}
                                    </Button>
                                  )}
                              </>
                            )}
                            <Button
                              onClick={() => {
                                logout();
                              }}
                              className="btn text-start w-100 mb-3 d-flex align-items-center"
                              style={{ padding: "6px 0px" }}
                              variant={"light"}
                            >
                              <Icon.ArrowBarLeft className="me-2" />
                              {"Logout"}
                            </Button>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <Button
                        variant="secondary"
                        className="d-flex align-items-center justify-content-center p-0 profile-section"
                        style={{ marginLeft: "6px" }}
                      >
                        <Icon.PersonCircle size={25} className="me-1" />
                        <p style={{ width: "100%", margin: "0px" }}>
                          {/* {userDetails?.username || ""} */}
                          {userDetails?.first_name !== null &&
                          userDetails?.last_name !== null ? (
                            <div className="d-flex gap-2">
                              <span>{userDetails.first_name}</span>
                              <span>{userDetails.last_name}</span>
                            </div>
                          ) : (
                            userDetails.email
                          )}
                        </p>
                        <Icon.ChevronDown size={15} className="mt-2" />
                      </Button>
                    </OverlayTrigger>
                  </Nav>
                </Offcanvas.Body>
              </Offcanvas>
            )
          ) : (
            <Navbar.Collapse
              id="navbarScroll"
              style={
                !isLargeDevice
                  ? { flexBasis: "auto", flexGrow: "unset", display: "block" }
                  : null
              }
            >
              <Nav
                className=" my-2 my-lg-0"
                style={{ maxHeight: "100px" }}
                navbarScroll
              ></Nav>
              <div className="d-flex text-center align-items-center justify-content-center p-0 m-0 w-100"></div>
              {roleOptions?.length ? (
                <div
                  className="d-flex justify-content-center align-items-center me-5 navbar-role"
                  style={{ minWidth: "20%" }}
                >
                  <Select
                    options={roleOptions}
                    value={selectedRoleObj ? selectedRoleObj : null}
                    onChange={handleRoleChange}
                    classNamePrefix="select"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary: "#ef8860",
                      },
                    })}
                  />
                </div>
              ) : null}

              <div
                className="d-flex justify-content-end align-items-center mx-5 navbar-role"
                style={{ cursor: "pointer" }}
                onClick={handleSearchBox}
              >
                <InputGroup className="rounded-pill">
                  <Form.Control
                    placeholder="Search Docs"
                    aria-label="search"
                    aria-describedby="basic-addon2"
                    readOnly
                    style={{
                      cursor: "pointer",
                      borderTopLeftRadius: "50px",
                      borderBottomLeftRadius: "50px",
                    }}
                  />
                  <InputGroup.Text
                    id="basic-addon2"
                    className="bg-primary text-white"
                    style={{
                      borderTopRightRadius: "50px",
                      borderBottomRightRadius: "50px",
                    }}
                  >
                    <Icon.Search />
                  </InputGroup.Text>
                </InputGroup>
              </div>
            </Navbar.Collapse>
          )}
          <SearchLoan
            show={showLoanSearch}
            onHide={() => setShowLoanSearch(false)}
          />
        </Container>
        <style>
          {`
        .notification-dot {
          height: 6px;
          width: 6px;
          background-color: #FF8057;
          border-radius: 50%;
          border: 1px solid white;
          display: flex;
          position: relative;
          top: -8px;
          left: -8px;
        }
        
        .nav-link {
         color: #222
        }
        
        .nav-link:hover, .nav-link:focus {
          color: #222;
        }`}
        </style>
      </Navbar>
    </>
  );
};
export default SSLNavbar;

export const SelectAccount = ({
  isABorrower,
  selectedRoleName,
  showOnlyActive = false,
  showDefault = false,
}) => {
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const selectedRoleObj = useSelector((state) => state.account.selectedRole);
  const manualSelectedAccount = useSelector(
    (state) => state.account.manualSelectedAccount
  );
  const { resetController } = useAbortController();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAccountSubmit = (e) => {
    if (e?.value) {
      if (leaveLoanDetailsOnAccountSwitch(location.pathname, isABorrower)) {
        dispatch(handleTermsPopup(true));
        navigate("/");
      }
      resetController();
      dispatch(setSelectedAccount(e));
      dispatch(setLenderID(e?.value));
      dispatch(setManualSelectedAccount(e));
      dispatch(setDashboardStatus("idle"));
      toast.success("Account Changed", {
        ...commonToast,
      });
    }
  };

  function borrowerOptions(selectedRoleObj) {
    const paidOffYes = JSON.parse(localStorage?.getItem("accessed_user"))
      .account?.filter(
        (data) =>
          data.type === selectedRoleObj.value &&
          data.paidoff_yn?.toLowerCase() === "y"
      )
      ?.map((data) => ({
        label:
          // isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
          //   ? `${data?.fullname} : ${data?.account} : ${data?.paidoffdate}`
          //   :
          `${data?.fullname} - ${data?.account}`,
        value: data.recid,
        databasename: data.databasename,
      }));

    const paidOffNo = JSON.parse(localStorage?.getItem("accessed_user"))
      .account?.filter(
        (data) =>
          data.type === selectedRoleObj.value &&
          data.paidoff_yn?.toLowerCase() === "n"
      )
      ?.map((data) => ({
        label:
          // isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
          //   ? `${data?.fullname} : ${data?.account} : ${data?.paidoffdate}`
          //   :
          `${data?.fullname} - ${data?.account}`,
        value: data.recid,
        databasename: data.databasename,
      }));

    let groupedOptions;

    if (paidOffNo?.length && !paidOffYes?.length) {
      groupedOptions = [{ label: "-- Active --", options: [...paidOffNo] }];
    } else if (!paidOffNo?.length && paidOffYes?.length) {
      groupedOptions = [{ label: "—- Paid off -—", options: [...paidOffYes] }];
    } else if (paidOffNo?.length && paidOffYes?.length) {
      groupedOptions = [
        { label: "-- Active --", options: paidOffNo },
        { label: "—- Paid off -—", options: paidOffYes },
      ];
    }

    if (showOnlyActive) {
      return [{ label: "-- Active --", options: [...paidOffNo] }];
    } else {
      return groupedOptions;
    }
  }

  const sortedOptions = borrowerOptions(selectedRoleObj);

  return (
    <Select
      // options={accountOptions}
      options={
        selectedRoleName?.includes("Borrower") ? sortedOptions : accountOptions
      }
      value={
        isABorrower
          ? showDefault
            ? manualSelectedAccount
              ? manualSelectedAccount
              : sortedOptions?.length
              ? sortedOptions[0]
              : null
            : manualSelectedAccount
            ? manualSelectedAccount
            : null
          : selectedAccount
          ? selectedAccount
          : null
      }
      onChange={handleAccountSubmit}
      // styles={customStyles}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary: "#ef8860",
        },
      })}
      // theme={(theme) => customTheme(theme, selectedAccount)}
      className="w-100 my-3 text-start"
      formatGroupLabel={isABorrower ? formatGroupLabel : null}
    />
  );
};
